<template>
    <div ref="mapContainer" :style="{ height: `${ mapHeight }px` }" class="space-map" />
</template>

<script>
    import { Map, Marker, config } from '@maptiler/sdk';
    import '@maptiler-sdk/css';
    import { getViewData } from '../../modules/view-data';
    import MapUtilities from '../../modules/MapUtilities';

    export default {
        name: 'space-map',

        props: {
            lat: {
                type: Number,
                default: 0,
            },

            lng: {
                type: Number,
                default: 0,
            },

            icon: {
                type: HTMLImageElement,
                default: null,
            },

            height: {
                type: Number,
                default: 300,
            },

            controlsPosition: {
                type: String,
                default: 'bottom-right',
            },
        },

        data() {
            return {
                map: null,
                marker: null,
            };
        },

        computed: {
            /**
             * Set the map height
             * @returns {Number}
             */
            mapHeight() {
                if (this.$root.viewport === 'xs' || this.$root.viewport === 'sm') {
                    return 300;
                }

                return this.height;
            },
        },

        mounted() {
            this.initMap();
            this.addMarker();
        },

        methods: {
            /**
             * Initialize the map
             */
            initMap() {
                const apiKey = getViewData('env.MAPTILER_API_KEY');
                const mapId = getViewData('env.MAPTILER_MAP_ID');

                if (!this.lng || !this.lng || !apiKey || !mapId) {
                    console.warn(
                        'MapTiler map isn\'t initialized. Check the properties or environment variables.'
                    );
                    return;
                }

                config.apiKey = apiKey;

                this.map = new Map({
                    container: this.$refs.mapContainer,
                    style: mapId,
                    center: [this.lng, this.lat],
                    zoom: 14,
                    minZoom: 7,
                    maxZoom: 17,
                    maptilerLogo: true,
                    pitch: 0,
                    scrollZoom: false,
                    geolocateControl: false,
                    navigationControl: this.controlsPosition,
                });
            },

            /**
             * Add a marker to the map
             */
            addMarker() {
                this.marker = new Marker({
                    element: this.icon ? this.icon : MapUtilities.get('selectedSpaceMap'),
                    anchor: 'bottom',
                })
                .setLngLat([this.lng, this.lat])
                .addTo(this.map);
            },
        },
    };
</script>

<style lang="less" scoped>
    .space-map {
        width: 100%;
        position: relative;
        z-index: 1;
    }
</style>
